import axios from '../../api/intercepors';
import { getUsersUrl } from '../../config/api.config';
import { IUserProfile } from '../../store/user/user.interface';

export const UserService = {
  async getProfile() {
    const sessionToken = localStorage.getItem('st');
    const { data } = await axios.get(getUsersUrl('/user-profile'), {
      headers: {
        'session-token': String(sessionToken),
      },
    });
    return data;
  },
};
